import type { CompaniesIndustry } from '@xing-com/crate-common-graphql-types';

import type { IndustryItem } from '../types';

import {} from 'react-intl';

export const createCompanyIndustry = (
  item: CompaniesIndustry,
  category?: string
): IndustryItem => ({
  id: item?.industry?.id || '',
  key: item?.industry?.localizationKey || '',
  title: item?.industry?.localizationKey || '',
  totalCompanies: item?.total || 0,
  seoName: item?.industry?.seoName || 'undefined',
  category,
  background: item?.bgColor || '',
});

export const createCompaniesIndustries = (
  items: CompaniesIndustry[],
  category?: string
): IndustryItem[] => items.map((item) => createCompanyIndustry(item, category));
